import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg width={17} height={16} viewBox="0 0 17 16" fill="none" {...props}>
      <Path
        d="M16 3.804V1.778C16 .8 15.2 0 14.222 0H1.778C.79 0 0 .8 0 1.778v12.444C0 15.2.791 16 1.778 16h12.444C15.2 16 16 15.2 16 14.222v-2.026c.524-.312.889-.872.889-1.53V5.334c0-.657-.365-1.217-.889-1.529zm-.889 1.53v5.333H8.89V5.333h6.222zM1.778 14.221V1.778h12.444v1.778H8.89c-.978 0-1.778.8-1.778 1.777v5.334c0 .977.8 1.777 1.778 1.777h5.333v1.778H1.778z"
        fill="#000"
      />
    </Svg>
  );
}

export default SvgComponent;
